import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export const SalaryAuditModal = ({
  isOpen,
  onClose,
  auditLogs,
  formatMonth,
  formatCurrency
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl" data-testid="audit-modal">
        <DialogHeader>
          <DialogTitle className="font-heading">Salary Audit History</DialogTitle>
        </DialogHeader>

        <div className="max-h-96 overflow-y-auto">
          {auditLogs.length === 0 ? (
            <p className="text-center text-slate-500 py-8">No audit logs found</p>
          ) : (
            <div className="space-y-4">
              {auditLogs.map((log) => (
                <div key={log.id} className="p-4 bg-slate-50 rounded-lg">
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex items-center gap-2">
                      <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                        log.action === 'created' ? 'bg-blue-100 text-blue-700' :
                        log.action === 'updated' ? 'bg-amber-100 text-amber-700' :
                        log.action === 'verified' ? 'bg-emerald-100 text-emerald-700' :
                        log.action === 'approved' ? 'bg-purple-100 text-purple-700' :
                        'bg-slate-100 text-slate-700'
                      }`}>
                        {log.action?.toUpperCase()}
                      </span>
                      <span className="text-sm text-slate-600">{formatMonth(log.month)}</span>
                    </div>
                    <p className="text-xs text-slate-500">
                      {new Date(log.created_at).toLocaleString()}
                    </p>
                  </div>
                  <p className="text-sm text-slate-600">{log.remarks}</p>
                  {log.new_values?.net_pay && (
                    <div className="mt-2 text-xs text-slate-500">
                      Net Pay: {formatCurrency(log.new_values.net_pay)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SalaryAuditModal;
